/* eslint-disable @typescript-eslint/no-explicit-any */
export const getTimeZones = (): string[] =>
  'supportedValuesOf' in Intl ? (Intl as any).supportedValuesOf('timeZone') : [];
